import { Variants } from "framer-motion";
import transitions from "@styles/design-tokens/09.transitions/transitions";

export const navVariants: Variants = {
  open: {
    x: 0,
    transition: {
      ease: transitions.timingFunctions["in-out-quart"],
      duration: 0.5,
    },
  },
  closed: {
    x: "100%",
    transition: {
      ease: transitions.timingFunctions["in-out-quart"],
      duration: 0.5,
    },
  },
};
export const navListVariants: Variants = {
  open: {
    opacity: 1,
    transition: {
      duration: 0,
      staggerChildren: 0.15,
    },
  },
  closed: {
    opacity: 0,
    transition: {
      delay: 0,
      duration: 0.2,
      delayChildren: 0.5,
    },
  },
};
export const navItemVariants = {
  open: { opacity: 1, x: 0, transition: { duration: 0.4 } },
  closed: { opacity: 0, x: -100 },
};
